import ApRoutes from "./components/routes";
import "../src/components/assets/style.css";
import { SnackbarProvider } from "notistack";
import CloseSnackBar from "./components/customComponents/CloseNotificationBar";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./components/theme/MuiTheme";
import { ContextAdmin } from "./hooks/UseAdminContext";

// 🟡 Import your context

function App() {
  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        maxSnack={3}
        autoHideDuration={5000}
        action={(snackbarKey) => <CloseSnackBar snackbarKey={snackbarKey} />}
      >
        {/* ✅ Wrap your app with ContextAdmin */}
        <ContextAdmin>
          <ApRoutes />
        </ContextAdmin>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
